module.exports = __webpack_public_path__ + "img/pdf.70e71f64.svg";